import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { Tooltip, Typography } from '../../ecosystem';
import { QABButton } from '../../ecosystem/mybswh';

const ToolTip_ActionBar = 'tooltip-actionbar';
const ToolTip_ActionBar_Billpay = 'tooltip-actionbar-billpay';
const ToolTip_ActionBar_Completed = 'tooltip-actionbar-completed';
const ToolTip_HeroSection_ProxyPicker = 'tooltip_herosection_proxypicker';

const QuickActionBar = ({
        dashBoardDetails = null,
        isMobile,
        onBoardingToolTipState,
        updateonBoardingToolTipState,
        disabled,
        isShowAllUsers,
        collapsed
    }) => {

    const displayBadgeForBillPay = dashBoardDetails?.data?.currentUser?.billing?.displayBadge;
    const UnreadMessages = isShowAllUsers ? dashBoardDetails?.data?.unreadMessageCount : dashBoardDetails?.data?.currentUser?.messages?.unreadCount;
    const TotalNewResults = isShowAllUsers ? dashBoardDetails?.data?.unreadTestsCount : dashBoardDetails?.data?.currentUser?.testResults?.unreadCount;
    console.info(`AuickActionBar TotalNewResults, dashBoardDetails`, TotalNewResults, dashBoardDetails);
    const medsTitle = isMobile ? "Meds" : "Medications";
    const resultsTitle = isMobile ? "Results" : "Test Results";
    const actionBarTooltipText = "We also moved some of the popular features to the top of the screen for quicker access.";
    const actionBarTooltipLinkText = "Continue";

    const billPayTooltipText = "Keep your billing easy and organized with paperless billing. If you would like to opt out, tap here to make any changes.";
    const billPayTooltipLinkText = "Continue";

    let qabClasses = "text-center col-3";
    let qabVariant = "default";
    let qabLabelPosition = "bottom";
    let qabShowLabel = true;

    if (collapsed) {
        qabClasses = "col";
        qabVariant = "circle";
        qabLabelPosition = "right";
        qabShowLabel = isMobile ? false : true;
    }

    const colClasses = `quick-action-bar__button ${qabClasses}`;

    const setQABPath = (path) => {
        return isShowAllUsers ? `familyselection${path}` : path;
    }

    return (<Tooltip text={actionBarTooltipText}
        tooltipId="action-bar-tooltip"
        variant="spotlight"
        linkText={actionBarTooltipLinkText}
        open={onBoardingToolTipState === ToolTip_ActionBar}
        linkOnClick={
            () => {
                updateonBoardingToolTipState(ToolTip_ActionBar_Billpay);
            }
        }
        placement={(isMobile || collapsed) ? "bottom" : "top"}
    >
        <div className={`row quick-action-bar ${isMobile ? 'quick-action-bar--mobile' : ''}`}>        
            <div className={colClasses}>
                <QABButton count={UnreadMessages}
                    disabled={disabled}
                    icon="message"
                    isMobile={isMobile}
                    labelPosition={qabLabelPosition}
                    showLabel={qabShowLabel}
                    variant={qabVariant}
                    onClick={
                        () => {
                            logUI("MBHWeb.UI.QuickActionBar.Messages.Clicked", new Date(), Tools.getURLPath());
                        }
                    }
                    to={setQABPath("/messagesAll")}
                    showBadge={
                        UnreadMessages > 0 ? true : false
                    }
                    title="Messages" />
            </div>
            <div className={colClasses}>
                <QABButton count={
                    TotalNewResults > 0 && TotalNewResults
                }
                    disabled={disabled}
                    icon="results"
                    isMobile={isMobile}
                    labelPosition={qabLabelPosition}
                    showLabel={qabShowLabel}
                    variant={qabVariant}
                    onClick={
                        () => {
                            logUI("MBHWeb.UI.QuickActionBar.TestResults.Clicked", new Date(), Tools.getURLPath());
                        }
                    }
                    to={setQABPath("/testresults")}
                    showBadge={
                        TotalNewResults > 0 ? true : false
                    }
                    title={resultsTitle} />
            </div>
            <div className={colClasses}>
                <QABButton icon="medications"
                    disabled={disabled}
                    isMobile={isMobile}
                    labelPosition={qabLabelPosition}
                    showLabel={qabShowLabel}
                    variant={qabVariant}
                    onClick={
                        () => {
                            logUI("MBHWeb.UI.QuickActionBar.Medications.Clicked", new Date(), Tools.getURLPath());
                        }
                    }
                    to={setQABPath("/currentmeds")}
                    title={medsTitle} />
            </div>
            <div className={colClasses}>
                <Tooltip
                    text={billPayTooltipText}
                    tooltipId="billpay-tooltip"
                    variant="spotlight"
                    linkText={billPayTooltipLinkText}
                    open={onBoardingToolTipState === ToolTip_ActionBar_Billpay}
                    onClick={
                        () => updateonBoardingToolTipState(ToolTip_HeroSection_ProxyPicker)
                    }
                    placement={(!collapsed && !isMobile) ? "top" : (isMobile && !collapsed ? "left" : "bottom-end")}>
                    <QABButton disabled={disabled}
                        icon="credit-card"
                        isMobile={isMobile}
                        labelPosition={qabLabelPosition}
                        showLabel={qabShowLabel}
                        variant={qabVariant}
                        onClick={
                            () => {
                                logUI("MBHWeb.UI.QuickActionBar.BillPay.Clicked", new Date(), Tools.getURLPath());
                            }
                        }
                        to={setQABPath("/accountsummary")}
                        showBadge={
                            displayBadgeForBillPay ? true : false
                        }
                        title="Bill Pay" />
                </Tooltip>
            </div>
        </div>
    </Tooltip>
    )
}

export default withRouter(QuickActionBar);
